import moment from "moment/moment";
import firebase from "firebase";
import {EventsTypes} from "@/enums/EventsTypes";
import {serializer} from "@/api/shared/serializer";
import {getRegionName} from "@/utils/functionsRegion";

import '@innovastudio/contentbuilder/public/contentbuilder/contentbuilder.css';
import '@innovastudio/contentbox/public/contentbox/contentbox.css';

import '../assets/contentbox/css/content.scss';
import '../assets/contentbox/css/box-flex.css';
/*import '../assets/contentbox/css/type-poppins.css';*/
import {CalendarEvent} from "vuetify";
import {ResidentStatus} from "@/enums/ResidentStatus";
import {ContentCustomWidgetsTypes} from "@/enums/ContentCustomWidgetsTypes";
import {ResidentAccessesOnMyhub} from "@/enums/ResidentAccessesOnMyhub";
import {DEFAULT_NO_IMAGE} from "@/consts/default-no-image";

export const CustomContentMixin = {
    data() {
        return {
            dataCustomContent: {
                isStartEvents: false,
                events: [],
                isStartGetMenu: false,
                menu: {},
                breakfast: [],
                lunch: [],
                dinner: [],
                dates: {},
                isStartDailyCalendar: false,
                dailyCalendar: {},
                isStartWeeklyCalendar: false,
                weeklyCalendar: {},
                isStartMonthlyCalendar: false,
                monthlyCalendar: [],
                isStartWeekBirthday: false,
                weeksBirthday: [],
                isStartLastWeekEvents: false,
                lastWeekEvents: [
                    { day: "Monday", events: [] },
                    { day: "Tuesday", events: [] },
                    { day: "Wednesday", events: [] },
                    { day: "Thursday", events: [] },
                    { day: "Friday", events: [] },
                    { day: "Saturday", events: [] },
                    { day: "Sunday", events: [] },
                ],
            },
            selectedWing: 'All'
        }
    },
    computed: {
        currentContent() {
            return this.$store.state.contentCreatorModule.currentContent;
        },
        currentWings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        customWidgetTypes() {
            return [
                ContentCustomWidgetsTypes.Menu,
                ContentCustomWidgetsTypes.Breakfast,
                ContentCustomWidgetsTypes.Lunch,
                ContentCustomWidgetsTypes.Dinner
            ]
        }
    },
    methods: {
        async getUpcomingEventsForCustomContent() {
            const fromDate = moment(new Date()).startOf("day").toDate();
            const toDate = moment(new Date()).endOf("day").toDate();
            this.dataCustomContent.events = [];

            await firebase
                .firestore()
                .collection("calender")
                .where("facilityId", "==", this.$store.state.authModule.currentFacility)
                .where("isPublished", "==", true)
                .where("start", ">=", fromDate)
                .where("start", "<=", toDate)
                .where("type", "in", [
                    EventsTypes.LifestylePrograms,
                    EventsTypes.Notice,
                    EventsTypes.PremiumServices,
                    EventsTypes.ConciergeRequest,
                    EventsTypes.Concierge,
                    EventsTypes.Medical,
                    EventsTypes.FamilyVisit
                ])
                .get()
                .then((querySnapshot) => {
                    let events = serializer.querySnapshotToDocuments(querySnapshot);

                    if (this.selectedWing !== "All") {
                        events = events.filter((x: any) => (x.wing === this.selectedWing) || (x.wing === "All") || (x.wing === null) || (x.wing === ''))
                    }

                    events.forEach((event: any) => {
                        this.dataCustomContent.events.push({
                            'imageUrl': event.imageUrl && event.imageUrl.includes("no-image") ? DEFAULT_NO_IMAGE : event.imageUrl,
                            'title': event.name,
                            'location': event.location,
                            'description': event.description,
                            'time': moment(event.start.seconds * 1000).format(this.$store.state.authModule.currentFacilityData.timeFormat)
                        });
                    });
                })
        },
        async getMenuForCustomContent() {
            try {
                return await firebase.app()
                  .functions(getRegionName())
                  .httpsCallable('getMenuByFacility')({
                      facilityId: this.$store.state.authModule.currentFacility,
                      startDate: moment(new Date()).format('YYYY-MM-DD'),
                      endDate: moment(new Date()).format('YYYY-MM-DD')
                  }).then((data) => {

                      if (data.data?.status === 400) {
                          this.$toast.open({
                              message: data.data?.error,
                              type: "error"
                          });
                      }

                      if (data.data?.status === 403) {
                          this.$toast.open({
                              message: data.data?.message,
                              type: "error"
                          });
                      }

                      if (data.data?.status === 404) {
                          this.$toast.open({
                              message: data.data?.code,
                              type: "error"
                          });
                      }

                      if (data.data?.data) {
                          const menus = data.data.data.Menus;
                          this.dataCustomContent.menu = this.getMenu(menus);
                          this.dataCustomContent.breakfast = this.getDishes(menus, "Breakfast");
                          this.dataCustomContent.lunch = this.getDishes(menus, "Lunch");
                          this.dataCustomContent.dinner = this.getDishes(menus, "Dinner");
                      }

                      return true;
                  })
            } catch (error) {
                console.error("An error occurred:", error);
            }
        },
        async getDailyEvents() {
            const fromDate = moment(new Date()).startOf("day").toDate();
            const toDate = moment(new Date()).endOf("day").toDate();
            this.dataCustomContent.dailyCalendar = {};

            await firebase
                .firestore()
                .collection("calender")
                .where("facilityId", "==", this.$store.state.authModule.currentFacility)
                .where("isPublished", "==", true)
                .where("start", ">=", fromDate)
                .where("start", "<=", toDate)
                .where("type", "in", [EventsTypes.LifestylePrograms, EventsTypes.PremiumServices])
                .get()
                .then((querySnapshot) => {
                    let data = serializer.querySnapshotToDocuments(querySnapshot);
                    const events = [];

                    if (this.selectedWing !== "All") {
                        data = data.filter((x: any) => (x.wing === this.selectedWing) || (x.wing === "All") || (x.wing === null) || (x.wing === ''))
                    }

                    data.forEach((event: CalendarEvent) => {
                        events.push({
                            start: `${moment(event.start.seconds * 1000).format("HH:mm")} - ${moment(event.end.seconds * 1000).format("HH:mm")}`,
                            name: event.name,
                            location: event.location,
                            description: event.description
                        })
                    });

                    this.dataCustomContent.dailyCalendar.day = moment(new Date()).format("dddd");
                    this.dataCustomContent.dailyCalendar.date = moment(new Date()).format("DD");
                    this.dataCustomContent.dailyCalendar.events = events;
              });
        },
        async getWeeklyEvents() {
            const fromDate = moment(new Date()).startOf('isoWeek').subtract(1, "day").set({hour: 1}).toDate();
            const toDate = moment(new Date()).endOf('isoWeek').subtract(1, "day").set({hour: 23, minutes: 59}).toDate();
            this.dataCustomContent.weeklyCalendar = {};

            await firebase
                .firestore()
                .collection("calender")
                .where("facilityId", "==", this.$store.state.authModule.currentFacility)
                .where("isPublished", "==", true)
                .where("start", ">=", fromDate)
                .where("start", "<=", toDate)
                .where("type", "in", [EventsTypes.LifestylePrograms, EventsTypes.PremiumServices])
                .get()
                .then((querySnapshot) => {
                    let data = serializer.querySnapshotToDocuments(querySnapshot);
                    const counts = {};
                    const events = {
                        Sun: [],
                        Mon: [],
                        Tue: [],
                        Wed: [],
                        Thu: [],
                        Fri: [],
                        Sat: []
                    }

                    if (this.selectedWing !== "All") {
                        data = data.filter((x: any) => (x.wing === this.selectedWing) || (x.wing === "All") || (x.wing === null) || (x.wing === ''))
                    }

                  data.forEach((event: CalendarEvent) => {
                      const key = moment(event.start.seconds * 1000).format("ddd");

                      events[key].push({
                          start: `${moment(event.start.seconds * 1000).format("HH:mm")} - ${moment(event.end.seconds * 1000).format("HH:mm")}`,
                          name: event.name,
                          location: event.location,
                          description: event.description
                      });

                      counts[key] = events[key].length
                  });

                  const maxEvents = Math.max.apply(null, Object.values(counts));

                  Object.entries(events).forEach(item => {
                      const key = item[0];
                      const data = item[1];
                      const sum = maxEvents - data.length;

                      if(sum > 0) {
                          for(let i = 0; i < sum; i++) {
                              events[key].push({})
                          }
                      }
                  });

                  this.dataCustomContent.weeklyCalendar = events;
              });
        },
        async getMonthlyEvents() {
            let fromDate = moment().startOf('month').startOf("day").toDate();
            let toDate = moment().endOf('month').endOf("day").toDate();
            this.dataCustomContent.monthlyCalendar = [];


            const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
            const offsetPastDays = moment(startOfMonth).day();

            if(offsetPastDays > 0) {
                const prevMonth = moment().subtract(1, 'month');
                fromDate = prevMonth.endOf('month').set({hour: 0, minutes: 0}).toDate();

                if (offsetPastDays > 1) {
                    fromDate = prevMonth.endOf('month').set({hour: 0,minutes: 0}).subtract((offsetPastDays - 1), 'days').toDate();
                }
            }


            const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
            const endOfWeek = moment(endOfMonth).endOf('isoWeek').subtract(1, 'day').format("YYYY-MM-DD");
            const offsetFutureDays = moment(endOfWeek).diff(endOfMonth, 'days');

            if(offsetFutureDays > 0) {
                const nextMonth = moment().add(1, 'month');
                toDate = nextMonth.startOf('month').set({hour: 0, minutes: 0}).toDate();

                if (offsetFutureDays >= 1) {
                    toDate = nextMonth.startOf('month').set({hour: 0,minutes: 0}).add((offsetFutureDays), 'days').toDate();
                }
            }

            await firebase
                .firestore()
                .collection("calender")
                .where("facilityId", "==", this.$store.state.authModule.currentFacility)
                .where("isPublished", "==", true)
                .where("start", ">=", fromDate)
                .where("start", "<=", toDate)
                .where("type", "in", [EventsTypes.LifestylePrograms, EventsTypes.PremiumServices])
                .get()
                .then(querySnapshot => {
                    let data = serializer.querySnapshotToDocuments(querySnapshot);
                    const events = [];

                    data.forEach((event: CalendarEvent) => {
                        const key: string = moment(event.start.seconds * 1000).format("MMM DD");
                        if(!events.find(x => x.day === key)) {
                            events.push({
                                day: key,
                                events: []
                            })
                        }
                    })

                    if (this.selectedWing !== "All") {
                        data = data.filter((x: any) => (x.wing === this.selectedWing) || (x.wing === "All") || (x.wing === null) || (x.wing === ''))
                    }

                    data.forEach((event: CalendarEvent) => {
                        const key: string = moment(event.start.seconds * 1000).format("MMM DD");
                        events.forEach(item => {
                            if (item.day === key) {
                                item.events.push({
                                    start: moment(event.start.seconds * 1000).format("HH:mm"),
                                    name: event.name,
                                    location: event?.location ?? ''
                                })
                            }
                        })
                    })

                    this.dataCustomContent.monthlyCalendar.push(...events);
              });
        },
        async getData(stringHtml) {
            const promises = [];

            if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.UpcomingEvents}"`) && !this.dataCustomContent.isStartEvents) {
                this.dataCustomContent.isStartEvents = true;
                this.getWing();
                promises.push(this.getUpcomingEventsForCustomContent())
            }

            if (this.customWidgetTypes.some(type => stringHtml.includes(`id="${type}"`)) && !this.dataCustomContent.isStartGetMenu) {
                this.dataCustomContent.isStartGetMenu = true;
                promises.push(this.getMenuForCustomContent());
            }

            if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.WeeklyCalendar}"`)  && !this.dataCustomContent.isStartWeeklyCalendar) {
                this.dataCustomContent.isStartWeeklyCalendar = true;
                this.getWing();
                this.getDates();
                promises.push(this.getWeeklyEvents())
            }

            if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.MonthlyCalendar}"`) && !this.dataCustomContent.isStartMonthlyCalendar) {
                this.dataCustomContent.isStartWeeklyCalendar = true;
                this.getWing();
                promises.push(this.getMonthlyEvents())
            }

            if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.DailyCalendar}"`) && !this.dataCustomContent.isStartDailyCalendar) {
                this.dataCustomContent.isStartDailyCalendar = true;
                this.getWing();
                promises.push(this.getDailyEvents())
            }

            if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.ThisWeeksBirthday}"`) && !this.dataCustomContent.isStartWeekBirthday) {
                this.dataCustomContent.isStartWeekBirthday = true;
                promises.push(this.getWeeksBirthdays())
            }

            if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.LastWeeksEvents}"`) && !this.dataCustomContent.isStartLastWeekEvents) {
                this.dataCustomContent.isStartLastWeekEvents = true;
                promises.push(this.getAllLastWeeksEvents())
            }

            return Promise.all(promises).then(() => {
                console.log("CONTENT DATA GENERATED")
            })
        },
        async getWeeksBirthdays() {
            const nextWeek = [
                moment().format("MMM-DD"),
                moment().add(1, "days").format("MMM-DD"),
                moment().add(2, "days").format("MMM-DD"),
                moment().add(3, "days").format("MMM-DD"),
                moment().add(4, "days").format("MMM-DD"),
                moment().add(5, "days").format("MMM-DD"),
                moment().add(6, "days").format("MMM-DD"),
            ];
            this.dataCustomContent.weeksBirthday = [];

            await firebase
              .firestore()
              .collection("residents")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("status","==", ResidentStatus.ActiveResident)
              .where("shortDob", 'in', nextWeek)
              .get()
              .then((querySnapshots) => {
                  let res = [];
                  const facilityData = this.$store.state.authModule.currentFacilityData;

                  if(facilityData.isDisplayBirthdaysOnMyHub) {
                      querySnapshots.docs.forEach((doc) => {
                          const resident = doc.data();
                          if(resident.accessesOnMyhub.find(x => x.name === ResidentAccessesOnMyhub.DisplayBirthday).isEnabled) {
                              res.push({
                                  imageUrl: resident.imageUrl,
                                  name: resident.name,
                                  date: moment(resident.dateOfBirth.seconds * 1000).format("MMM Do"),
                                  dateSort: moment(resident.dateOfBirth.seconds * 1000).format("MMM DD")
                              });
                          }
                      })

                      res = res.sort((a: any, b: any) => moment(a.dateSort).diff(moment(b.dateSort)));

                      this.dataCustomContent.weeksBirthday = res;
                  }
              })
        },
        async getAllLastWeeksEvents() {
            this.dataCustomContent.lastWeekEvents = [
                { day: "Monday", events: [] },
                { day: "Tuesday", events: [] },
                { day: "Wednesday", events: [] },
                { day: "Thursday", events: [] },
                { day: "Friday", events: [] },
                { day: "Saturday", events: [] },
                { day: "Sunday", events: [] },
            ];
            const fromDate = moment(new Date()).subtract(1, "week").startOf('isoWeek').toDate();
            const toDate =  moment(new Date()).subtract(1, "week").endOf('isoWeek').toDate();

            await firebase
              .firestore()
              .collection("calender")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("isPublished", "==", true)
              .where("start", ">=", fromDate)
              .where("start", "<=", toDate)
              .where("isDisplayInWeekSummary", "==", true)
              .get()
              .then((querySnapshot) => {
                  const data = serializer.querySnapshotToDocuments(querySnapshot);

                  data.forEach((event: any) => {
                      const day = moment(event.start.seconds * 1000).format('dddd');
                      this.dataCustomContent.lastWeekEvents.find(x => x.day === day).events.push({
                          'imageUrl': event.imageUrl && event.imageUrl.includes("no-image") ? DEFAULT_NO_IMAGE : event.imageUrl,
                          'title': event.name,
                          'location': event.location,
                          'description': event.description,
                          'time': moment(event.start.seconds * 1000).format(this.$store.state.authModule.currentFacilityData.timeFormat)
                      });
                  })
              })
        },
        getDishes(menus, type) {
            const result = [];

            menus.forEach(item => {
                const obj = {
                    meals: []
                };

                item.meals.forEach(meal => {
                    if(meal.label === type) {
                        obj.meals.push(meal);
                    }
                });

                result.push(obj)
            });

            return result;
        },
        getMenu(menus) {
            const result = {};

            menus[0].meals.forEach(item => {
                result[item.label] = item.plates[0].recipes;
            });

            return result;
        },
        getDates() {
            const currentDate = moment();
            const weekStart = currentDate.clone().startOf('isoWeek').subtract(1, "day");
            const dates = {
                Sun: null,
                Mon: null,
                Tue: null,
                Wed: null,
                Thu: null,
                Fri: null,
                Sat: null
            }
            this.dataCustomContent.dates = {}

            for (let i = 0; i <= 6; i++) {
                const key = moment(weekStart).add(i, 'days').format("ddd");
                dates[key] = moment(weekStart).add(i, 'days').format("DD");
                this.dataCustomContent.dates = dates;
            }
        },
        getWing() {
            if(this.currentContent?.selectedWing) {
                const wing = this.currentWings.find(x => x.id === this.currentContent.selectedWing);

                if(wing) {
                    this.selectedWing = wing.name;
                }
            }
        }
    }
}